import React, { useState, useRef, useId } from 'react';
interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactNode;
  side?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}
export function Tooltip({
  content,
  children,
  side = 'top',
  className = ''
}: TooltipProps) {
  const [open, setOpen] = useState(false);
  const id = useId();
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);
  const show = () => {
    if (timeout.current) clearTimeout(timeout.current);
    setOpen(true);
  };
  const hide = () => {
    timeout.current = setTimeout(() => setOpen(false), 60);
  };
  const positions: Record<string, string> = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2'
  };
  return <span className={`relative inline-flex ${className}`} onMouseEnter={show} onMouseLeave={hide} onFocus={show} onBlur={hide} data-id="element-2579" data-mp="1jszng12arjw2">
      <span aria-describedby={open ? id : undefined} className="inline-flex" data-id="element-2580" data-mp="vy5qupg3p6tn">
        {children}
      </span>
      {open && <span role="tooltip" id={id} className={`absolute z-50 w-max max-w-xs rounded-lg bg-evergreen px-3 py-2 text-xs leading-relaxed text-white shadow-lg ${positions[side]}`} data-id="element-2581" data-mp="10vffi2vo1egf">
          {content}
        </span>}
    </span>;
}